<div class="flex-direction-column gap-5">
  @if (label) {
    <span class="campo-label">{{ label }}</span>
  }

  @if (!contatoSelecionado) {
    <div class="campo-input-wrapper">
      <input class="campo-input-base campo-busca-contato-input" type="text" placeholder="Nome ou número do contato"
        [disabled]="disabled" [value]="texto" (input)="pesquisar($any($event.target).value)" />
    </div>

    @if (buscando) {
      <div class="campo-busca-contato-sugestoes">
        @for (i of [1, 2]; track i) {
          <div class="campo-skeleton-linha skeleton"></div>
        }
      </div>
    } @else if (sugestoes.length > 0) {
      <div class="campo-busca-contato-sugestoes">
        @for (contato of sugestoes; track contato.id) {
          <button type="button" class="campo-busca-contato-item" (click)="selecionar(contato)">
            <img [src]="iconeStatus(contato)" [matTooltip]="tooltipStatus(contato)" class="campo-busca-contato-status" alt="" />
            <span class="flex-direction-column">
              <span class="campo-busca-contato-nome">{{ contato.nome }}</span>
              <span class="campo-busca-contato-numero">{{ contato.numero | celularMask }}</span>
            </span>
          </button>
        }
      </div>
    } @else if (tocado && texto.trim().length >= 2) {
      <span class="campo-busca-contato-vazio">Nenhum contato encontrado.</span>
    }
  } @else {
    <div class="campo-busca-contato-chip">
      <img [src]="iconeStatus(contatoSelecionado)" [matTooltip]="tooltipStatus(contatoSelecionado)" class="campo-busca-contato-status" alt="" />
      <span class="flex-direction-column campo-busca-contato-info">
        <span class="campo-busca-contato-nome">{{ contatoSelecionado.nome }}</span>
        <span class="campo-busca-contato-numero">{{ contatoSelecionado.numero | celularMask }}</span>
      </span>
      @if (permitirRemover) {
        <button type="button" class="campo-busca-contato-remover" title="Trocar contato" (click)="remover()">
          <img src="./assets/icones/redesign/inputs/container-cancel.svg" alt="" />
        </button>
      }
    </div>
  }
</div>
